import React, { Component } from "react";
import $ from "jquery";

class Saham extends Component {
    constructor(props) {
        super(props);
        this.getRequest();
    }
  state = {
    userRequestJson: [],
    errorMessage: "",
    stepNo: 1,
    isHomePage: true,
    isCertificateEmployment: false,
    isCertificateEmploymentRegister: false,
  };
  componentDidMount() {
    this.getRequest();
  }
  toggleCertificateEmployment = () => {
    this.setState({ isCertificateEmployment: true });
    this.setState({ isCertificateEmploymentRegister: false });
    this.setState({ isHomePage: false });
  };
  toggleCancelSaham = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
        var formdata = new FormData();
        formdata.append("token", token);
        formdata.append("RequestType", "decline");

        var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
        };

        fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/submit-user-saham-request`,
        requestOptions
        )
        .then((response) => response.text())
        .then((result) => {
            if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
                const errorMessage = myObject.message;
                this.props.toggleErrorMessage(errorMessage);
                this.props.toggleError();
                this.getRequest();
            }
            else{
                const errorMessage = myObject.message;
                this.props.toggleErrorMessage(errorMessage);
                this.props.toggleError();
            }
            }
        })
        .catch((error) => console.log("error", error));
    }
  };
  toggleRegister = () => {
    this.setState({ isCertificateEmployment: true });
    this.setState({ isCertificateEmploymentRegister: false });
    this.setState({ isHomePage: true });
  };
  getRequest = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("CompetitionRequestTypeRef", 6);      
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };
      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/user/get-user-saham-request`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
              this.setState(
                { userRequestJson: myObject.data },
                function() {}
              );
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  handleRequest = (e) => {
    this.declineRequest(e, "SahamTarjihi");
  };
  declineRequest = (e, RequestType) => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      var formdata = new FormData();
      formdata.append("token", token);
      formdata.append("ID_Request", e);
      formdata.append("CompetitionRequestTypeRef", 6);
      var requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/refahi/del-user-competition-request`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          if (result !== null) {
            // console.log(result);
            var myObject = JSON.parse(result);
            if (myObject.status === 0) {
                this.getRequest();
            } else {
              const errorMessage = myObject.message;
              this.props.toggleErrorMessage(errorMessage);
              this.props.toggleError();
            }
          }
        })
        .catch((error) => console.log("error", error));
    }
  };
  handleValue(event){
    // console.log(event.target.value);
    this.setState({exchangeCode: event.target.value});
  }
  thosandSepratorBlur = (el) => {
    var element = $("#" + el);
    if (element !== null) {
      var amount = $(element).val();
      var val = amount.replace(/,/g, "");
      var e = "۰".charCodeAt(0);
      var NewVal = val.replace(/[۰-۹]/g, function(t) {
        return t.charCodeAt(0) - e;
      });
      // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
      e = "٠".charCodeAt(0);
      NewVal = NewVal.replace(/[٠-٩]/g, function(t) {
        return t.charCodeAt(0) - e;
      });
      NewVal = NewVal.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
      var parts = NewVal.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      $(element).val(parts.join("."));
    }
  };
  render() {
    $(".NumberValid").on("input", function() {
      var e = "۰".charCodeAt(0);
      this.value = this.value.replace(/[۰-۹]/g, function(t) {
        return t.charCodeAt(0) - e;
      });
      // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
      e = "٠".charCodeAt(0);
      this.value = this.value.replace(/[٠-٩]/g, function(t) {
        return t.charCodeAt(0) - e;
      });
      this.value = this.value
        .replace(/[^0-9.]/g, "")
        .replace(/(\..*)\./g, "$1");
    });
    const myRequest = this.state.userRequestJson.map(
      (e) => (
        <li key={e.ID} className={"Array-item readClass"}>
          <div className="mb-2">
            <span className="bg-dark text-white wp-text-small rounded p-1">
              تاریخ ثبت درخواست {e.RequestTime}
            </span>
          </div>
          <div className="title mb-2 text-dark">
            <strong>جهت دریافت سهام ترجیحی شرکت آلومینیوم جنوب:</strong>
          </div>
          <div className="text-center">
            <span className={e.State_CSS}>
              <b>{e.Comment}</b>
            </span>
          </div>
          {e.Comment === "رضایت دارم" ? <div>
            <div className="alert alert-warning px-2 py-1 mt-2">
              <p className="mb-0 text-center">همکار گرامی این مرحله به عنوان پیش ثبت نام می باشد.</p>
              <p className="mb-0 text-center">ثبت نام نهایی با حضور در واحد منابع انسانی و تکمیل مدارک و تایید نهایی سازمان خصوصی سازی صورت می پذیرد.</p>
              <p className="mb-0 text-center">زمان و مکان حضور جهت تکمیل مدارک متعاقباً اعلام می گردد.</p>
            </div>
            <p className="wp-header text-right">اطلاعات هویتی</p>
                <p className="mb-0">
                  نام و نام‌خانوادگی:{" "}
                  <strong>{this.props.userJson.full_name}</strong>
                </p>
                <p className="mb-0">
                  شماره پرسنلی:{" "}
                  <strong>{this.props.userJson.personeliCode}</strong>
                </p>
                <p className="mb-0">
                  شماره ملی: <strong>{this.props.userJson.national_id}</strong>
                </p>
                <p className="mb-0">
                  تلفن همراه:{" "}
                  <strong>{this.props.userJson.mobile}</strong>
                </p>
                <p className="mb-0">
                  شماره شناسنامه:{" "}
                  <strong>{this.props.userJson.identity_id}</strong>
                </p>
                <p className="mb-0">
                  کد و سری شناسنامه:{" "}
                  <strong>{this.props.userJson.identity_code}</strong>
                </p>
                <p className="mb-0">
                  سریال شناسنامه:{" "}
                  <strong>{this.props.userJson.identity_serial}</strong>
                </p>
                <p className="mb-0">
                  کد بورسی:{" "}
                  <strong>{this.props.userJson.exchange_code}</strong>
                </p>
                <p className="mb-0">
                  کد پستی:{" "}
                  <strong>{this.props.userJson.postal_code}</strong>
                </p>
                <div className="alert alert-danger text-center mt-2">در صورت وجود هر گونه مغایرت نسبت به اصلاح آن هر چه سریعتر اقدام نمایید، در صورت عدم امکان ویرایش به واحد منابع انسانی مراجعه کنید.</div>
          </div>:null}
            <div className="text-left">
              <button
                type="button"
                onClick={() =>
                  this.handleRequest(e.ID)
                }
                className="btn btn-danger btn-sm rounded-pill py-0 px-2 small-font"
              >
                لغو درخواست
              </button>
            </div>
        </li>
      )
    );
    if (this.state.isHomePage === true) {
      return (
        <React.Fragment>
          <div className="w-100 body-padding">
            <React.Fragment>
                <p className="wp-header small">وضعیت سهام ترجیحی</p>
                <ul className="Array p-0">
                  {myRequest.length === 0 ? (
                    <li className="Array-item">
                      <div className="title text-danger mb-2">
                        هنوز وضعیت سهام ترجیحی توسط شما مشخص نشده است.
                      </div>
                      <div className="item text-center">
                    <div className="alert alert-info te">
                      <p className="mb-0 text-justify">همکار گرامی شما مشمول دریافت سهام ترجیحی شرکت مجتمع صنایع آلومینیوم جنوب شده‌اید، بدیهی است طبق قوانین سازمان خصوصی سازی، پرسنل هر سازمان فقط یک بار حق انتخاب جهت دریافت یا عدم دریافت سهام ترجیحی آن شرکت را دارد.</p>
                    </div>
                        <p>اینجانب <b>{this.props.userJson.full_name}</b> با کد پرسنلی <b>{this.props.userJson.personeliCode}</b> در خصوص اختصاص سهام ترجیحی شرکت صنایع آلومینیوم جنوب نظر خود را به شرح ذیل اعلام می‌نمایم.</p>
                      <button
                        onClick={this.toggleCertificateEmployment}
                        className="btn btn-success rounded-0"
                      >
                        <span>رضایت دارم</span>
                      </button>
                      <button
                        onClick={this.toggleCancelSaham}
                        className="btn btn-danger rounded-0"
                      >
                        <span>رضایت ندارم</span>
                      </button>
                      <div className="w-100"></div>
                      <div className="text-right mt-2">
                        <small><span className="text-danger">*</span> در صورت رضایت به ثبت نام نسبت به صحت اطلاعات خود اطمینان حاصل کنید.</small>
                        <br></br>
                        <small><span className="text-danger">**</span> شماره تماس وارد شده باید به اسم خود شخص باشد.</small>
                      </div>
                    </div>
                    </li>
                  ) : (
                    myRequest
                  )}
                </ul>
            </React.Fragment>
          </div>
        </React.Fragment>
      );
    } else if (this.state.isCertificateEmployment === true) {
      return (
        <React.Fragment>
          <div className="w-100 body-padding">
              <div className="bg-light mt-2 p-2">
                <p className="wp-header text-center">فرم تعهد نامه سهام ترجیحی</p>
                <p className="mb-0">
                  نام و نام‌خانوادگی:{" "}
                  <strong>{this.props.userJson.full_name}</strong>
                </p>
                <p className="mb-0">
                  شماره پرسنلی:{" "}
                  <strong>{this.props.userJson.personeliCode}</strong>
                </p>
                <p className="mb-0">
                  شماره ملی: <strong>{this.props.userJson.national_id}</strong>
                </p>
                <p className="mb-0">
                  تلفن همراه:{" "}
                  <strong>{this.props.userJson.mobile}</strong>
                </p>
                <p className="text-justify mt-2">
                    در صورت مشاهده مغایرت در اطلاعات هویتی خود حتماً آن را به واحد منابع انسانی اطلاع دهید. در هنگام مراجعه جهت تکمیل فرم سهام خود حتماً کدبورسی و کد پستی خود را به همراه داشته باشید.
                </p>
                <div className="text-primary font-weight-bold">کد بورسی <small className="text-danger font-weight-bold">*</small></div>
                <input
                  id="exchangeCode"
                  type="text"
                  placeholder="کد بورسی"
                  className="form-control"
                  defaultValue={this.props.userJson.exchange_code}
                ></input>
                <small className="text-danger font-weight-bold">مثلاً: ع اژ92661</small>
                <div className="text-primary font-weight-bold mt-2">کد پستی <small className="text-danger font-weight-bold">*</small></div>
                <input
                  id="postalCode"
                  type="text"
                  placeholder="کد پستی"
                  className="form-control mt-2"
                  defaultValue={this.props.userJson.postal_code}
                ></input>
                <div className="text-primary font-weight-bold mt-2">شماره شناسنامه <small className="text-danger font-weight-bold">*</small></div>
                <input
                  id="identityId"
                  type="text"
                  placeholder="شماره شناسنامه"
                  className="form-control mt-2"
                  defaultValue={this.props.userJson.identity_id}
                ></input>
                <div className="text-primary font-weight-bold mt-2">کد و سری شناسنامه <small className="text-danger font-weight-bold">*</small></div>
                <input
                  id="identityCode"
                  type="text"
                  placeholder="کد و سری شناسنامه"
                  className="form-control mt-2"
                  defaultValue={this.props.userJson.identity_code}
                ></input>
                <small className="text-danger font-weight-bold">مثلاً: الف 36</small>
                <div className="text-primary font-weight-bold mt-2">سریال شناسنامه <small className="text-danger font-weight-bold">*</small></div>
                <input
                  id="identitySerial"
                  type="text"
                  placeholder="سریال شناسنامه"
                  className="form-control mt-2"
                  defaultValue={this.props.userJson.identity_serial}
                ></input>
                <small className="text-danger font-weight-bold">مثلا: 458245   </small>
                <div className="text-left mt-2">
                  <button
                    className="btn btn-danger rounded-0"
                    onClick={this.toggleRegister}
                  >
                    انصراف
                  </button>
                  <button
                    className="btn btn-primary rounded-0"
                    onClick={this.submitForm}
                  >
                    ثبت درخواست
                  </button>
                </div>
              </div>
          </div>
        </React.Fragment>
      );
    } else {
    }
  }
  submitForm = () => {
    var errorMessage = "مجدد وارد سامانه شوید، نشست شما به پایان رسیده است.";
    const token = localStorage.getItem("token");
    if (token !== null) {
        var exchangeCode = document.getElementById("exchangeCode").value;
        var postalCode = document.getElementById("postalCode").value;
        var identityId = document.getElementById("identityId").value;
        var identityCode = document.getElementById("identityCode").value;
        var identitySerial = document.getElementById("identitySerial").value;
        if (exchangeCode !== null && exchangeCode.length > 0 && postalCode !== null && postalCode.length === 10 && identitySerial !== null && identitySerial.length > 0) {
          var formdata = new FormData();
          formdata.append("token", token);
          formdata.append("RequestType", "SahamTarjihi");
          formdata.append("exchangeCode", exchangeCode);
          formdata.append("postalCode", postalCode);
          formdata.append("identityId", identityId);
          formdata.append("identityCode", identityCode);
          formdata.append("identitySerial", identitySerial);
          var requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow",
          };

          fetch(
            `${process.env.REACT_APP_BASE_API_URL}/api/user/submit-user-saham-request`,
            requestOptions
          )
            .then((response) => response.text())
            .then((result) => {
              if (result !== null) {
                var myObject = JSON.parse(result);
                if (myObject.status === 0) {
                  errorMessage = "درخواست شما ثبت شد، توجه داشته باشید این مرحله به عنوان پیش ثبت نام می‌باشد. زمان و مکان حضور جهت تکمیل مدارک متعاقباً اعلام می گردد.";
                  this.props.getFullProfile();
                  this.props.toggleErrorMessage(errorMessage);
                  this.props.toggleError();
                  this.toggleRegister();
                  this.getRequest();
                } else {
                  errorMessage = myObject.message;
                  this.props.toggleErrorMessage(errorMessage);
                  this.props.toggleError();
                }
              }
            })
            .catch((error) => console.log("error", error));
        } else {
          errorMessage = "وارد کردن تمامی اطلاعات فرم تعهدنامه ضروری می باشد.";
          this.props.toggleErrorMessage(errorMessage);
          this.props.toggleError();
        }
    } else {
      this.props.toggleErrorMessage(errorMessage);
      this.props.toggleError();
    }
  };
}
export default Saham;
